/**
 * Capacidade de alunos do ambiente — o mesmo cálculo de `Domain/Rules/Ambientes/CapacidadeAmbiente.cs`
 * da API, que é quem decide de verdade (a tela só antecipa o número).
 *
 * O coeficiente é de ALUNOS POR m², como pede o requisito: capacidade = piso(área × coeficiente).
 *
 * A conta é feita em INTEIROS (centésimos de m² × décimos-milésimos de aluno/m²) para não cair
 * no erro de ponto flutuante: em `number`, 0,29 × 100 dá 28,999999999999996, e o piso disso é 28,
 * não 29 — a tela mostraria um número diferente do que o servidor grava.
 */
export const CASAS_AREA = 2;
export const CASAS_COEFICIENTE = 4;
export const AREA_MAXIMA = 32767;
export const COEFICIENTE_MAXIMO = 10;
export const CAPACIDADE_MAXIMA = 32767;

export function calcularCapacidade(
  area: number | null | undefined,
  coeficiente: number | null | undefined,
): number | null {
  if (area == null || coeficiente == null || !(area > 0) || !(coeficiente > 0)) return null;

  const areaCentesimos = Math.round(area * 100);
  const coeficienteDecimosMilesimos = Math.round(coeficiente * 10000);

  const produto = areaCentesimos * coeficienteDecimosMilesimos; // inteiro exato (< 2^53)

  // Divisão inteira sem passar por fração: piso(produto / 1.000.000).
  return (produto - (produto % 1000000)) / 1000000;
}

/** Quantas casas decimais o número digitado tem ("12,50" conta 2). */
export function casasDecimais(valor: number): number {
  if (!Number.isFinite(valor)) return 0;
  const texto = String(valor);
  if (texto.includes('e-')) return Number(texto.split('e-')[1]) || 0;
  const ponto = texto.indexOf('.');
  return ponto < 0 ? 0 : texto.length - ponto - 1;
}
